import { dsTemplateThumbnailSID, TemplateThumbnailDirective } from './directive';

export { TemplateThumbnailController } from './controller';
export { TemplateThumbnailDirective } from './directive';

angular.module('app').directive(dsTemplateThumbnailSID, [TemplateThumbnailDirective]);
